import React from "react";
import styled from "styled-components";

import { StyledChip, StyledAvatar, StyledText } from "./UserChip";

const StyledLogo = styled(StyledAvatar)`
  background-image: ${({ data }) => `url(${data.imageUrl});`} !important;
`;

const StyledCompanyName = styled.span`
  color: ${({ darkText }) => (darkText ? "black" : "white")};
`;

const CompanyChip = ({ company, style, clicked, darkText }) => {
  if (!company || !company.data) return null;
  return (
    <div style={{ display: "inline-block", verticalAlign: "middle" }}>
      <StyledChip styled={style} onClick={clicked}>
        <StyledLogo data={company} />
        <StyledText>
          <StyledCompanyName darkText={darkText}>{company.name}</StyledCompanyName>
        </StyledText>
      </StyledChip>
    </div>
  );
};

export default CompanyChip;
